<template>
  <section>
      <b-row class="mb-3">
        <b-col cols="2">
            <b-form-group label-cols="3" label="Received" label-size="lg" label-for="receivedQC">
              <b-form-input type="number" id="receivedQC" v-model="lineReceiveObj.received" @blur="onReceiveInput" />
            </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-button size="sm" variant="outline-primary" v-b-modal="'inspection-report-modal'" class="mr-2">
            <span class="fa fa-check mr-1" ></span>RMA Inspection
          </b-button>
          <b-button size="sm" variant="outline-primary" @click="$refs['rmaLine-ncmReport-modal'].show()">
            <span class="fa fa-file mr-1"></span>Create NCM
          </b-button>
        </b-col>
      </b-row>
      <div v-if="lineReceiveObj.showDetails">
        <table
          v-for="(formObj, index) in receiveDetailsArr"
          :key="index">
            <tr>
              <th></th>
              <th>Quantity <span class="required-field">*</span></th>
              <th>{{ (formObj.isSplit) ? '' : 'Date Code'}}</th>
              <th>{{ (formObj.isSplit) ? '' : 'Lot'}}</th>
              <th>{{ (formObj.isSplit) ? '' : 'Revision'}}</th>
              <th>{{ (formObj.isSplit) ? '' : 'Condition'}} <span v-if="!formObj.isSplit" class="required-field">*</span></th>
              <th>{{ (formObj.isSplit) ? '' : 'COO'}} <span v-if="!formObj.isSplit" class="required-field">*</span></th>
              <th v-if="formObj.rejected">Reject Reason</th>
              <th>Comment</th>
              <th></th>
              <th></th>
              <th>Warehouse  <span class="required-field">*</span></th>
              <th>Location  <span class="required-field">*</span></th>
            </tr>
            <tr>
              <td>
                <i @click="onDeleteRow(index)" class="table-action-icon-delete fa fa-trash"></i>
              </td>
              <td>
                <b-input-group>
                  <template v-slot:append>
                    <b-button :variant="(formObj.isSplit) ? 'primary' : 'outline-primary'" @click="splitChange(index)">
                      <!-- <i class="fa fa-share-square"></i> -->
                      Split
                    </b-button>
                  </template>
                  <input
                      :min="0"
                      placeholder="0"
                      type="number"
                      class="form-control max-number-width"
                      v-model.number="formObj.quantity"
                      @input="onQuantityChange($event, index)"
                      @focus="tempQuantity[index] = parseInt(formObj.quantity, 10)"
                    />
                </b-input-group>
              </td>
              <td>
                <input v-model="formObj.dateCode" class="form-control" v-if="!formObj.isSplit" style="width: 100px;"
                :class="rmaLine.dateCode != formObj.dateCode ? 'highlight-text-field' : ''" disabled />
              </td>
              <td>
                <input v-model="formObj.lotCode" class="form-control" v-if="!formObj.isSplit" style="width: 80px;"
                  :class="rmaLine.lotCode != formObj.lotCode ? 'highlight-text-field' : ''" disabled />
              </td>
              <td>
                <input v-model="formObj.revision" class="form-control" v-if="!formObj.isSplit" style="width: 100px;"
                  :class="rmaLine.revision != formObj.revision ? 'highlight-text-field' : ''" disabled />
              </td>
              <td>
                <b-form-select
                    disabled
                    v-model="formObj.conditionId"
                    class="form-control"
                    v-if="!formObj.isSplit"
                    style="width:180px"
                    :class="rmaLine.conditionId != formObj.conditionId ? 'highlight-text-field' : ''"
                  >
                    <option
                      v-for="condition in sortSelect(conditions)"
                      :key="condition.id"
                      :value="condition.id"
                    >
                      {{ condition.name }}
                    </option>
                  </b-form-select>
              </td>
              <td>
                <b-form-select
                    disabled
                    v-model="formObj.countryOfOriginId"
                    style="width:200px"
                    class="form-control"
                    v-if="!formObj.isSplit"
                    :class="rmaLine.countryOfOriginId != formObj.countryOfOriginId ? 'highlight-text-field' : ''"
                    >
                    <option
                      v-for="countryCode in sortSelect(countryCodes)"
                      :key="countryCode.id"
                      :value="countryCode.id"
                    >
                      {{ countryCode.name }}
                    </option>
                  </b-form-select>
              </td>
              <td>
                <input v-model="formObj.comments" class="form-control" />
              </td>
              <td>
                <b-button class="form-control" v-b-modal="'serial-num-modal'+index" v-if="!formObj.isSplit">S/N</b-button>
                <b-modal
                  size="lg"
                  :id="'serial-num-modal'+index"
                  :ref="'serial-num-modal'+index"
                  ok-title="Save">
                  <template slot="modal-header">
                    <h5 class="modal-title">Serial Numbers</h5>
                  </template>
                  <h6>NOTE: Enter 1 serial number per line</h6>
                  <b-textarea v-model="formObj.serialNumbers" rows="15"></b-textarea>
                </b-modal>
              </td>
              <td>
                <b-button class="form-control" v-if="!formObj.isSplit" v-b-modal="'upload-image-'+index"><i class="fa fa-image" /></b-button>
              </td>
              <td>
                <b-form-select
                    class="form-control"
                    v-model="formObj.warehouseId"
                    style="width:150px">
                    <option
                      v-for="warehouse in sortSelect(warehouses)"
                      :key="warehouse.id"
                      :value="warehouse.id"
                    >
                      {{ warehouse.name }}
                    </option>
                  </b-form-select>
              </td>
              <td>
                <input v-model="formObj.location" class="form-control" />
              </td>
            </tr>
            <tr v-if="formObj.isSplit">
              <th></th>
              <th></th>
              <th>Quantity</th>
              <th>Date Code</th>
              <th>Lot</th>
              <th>Revision</th>
              <th>Condition</th>
              <th>COO</th>
              <th>Split Comment</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            <split-details
              v-for="(splitObj, i) in formObj.inventorySplits"
              :key="i" :ndx="i"
              :isSplit="formObj.isSplit"
              :splitObj="splitObj"
              @onSplitQuantityChange="onSplitQuantityChange($event, i, index)"
            />
            <b-modal :id="'upload-image-'+index" :ref="'upload-image-'+index" size="sm" :title="'Upload Image'">
                <b-form-file
                  multiple
                  v-model="formObj.images"
                  :file-name-formatter="formatNames"
                  :accept="fileTypes"
                ></b-form-file>
            </b-modal>
        </table>
      </div>

      <!-- QC Inspection -->
      <b-modal id="inspection-report-modal" ref="inspection-report-modal" size="lg"
               hide-footer header-close-label="Cancel" title="Inspection Report">
        <inspection-report-component :lineData="rmaLine" :isRma="true" />
      </b-modal>

      <ncm-report-component :modalId="'rmaLine-ncmReport-modal'" ref="rmaLine-ncmReport-modal" :rmaLineProp="rmaLine" />
  </section>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import SplitDetails from './splitDetails';
import NcmReportComponent from '@/pages/NonconformanceReport/components/Form'
import InspectionReportComponent from '@/shared/components/InspectionReport/components/Form'

import { DATE_FORMAT } from '@/shared/constants';

export default {
  components: {
    SplitDetails,
    NcmReportComponent,
    InspectionReportComponent
  },
  props: {
    ndx: {
      type: Number,
      default: 0
    },
    onRMA: {
      type: Boolean,
      default: false,
    },
    lineReceiveObj: {
      type: Object,
      default: () => {}
    },
    ncmReportObj: {
      type: Object,
      default: () => {}
    },
    receiveDetailsArr: {
      type: Array,
      default: () => []
    },
    rmaLine: {
      type: Object,
      default: () => {}
    },
    isShowReports: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: false,
      },
      tempReceive: 0,
      tempQuantity: [],
      fileTypes: [
        '.png',
        '.jpg',
        '.jpeg',
        '.gif'
      ].join(', '),
    }
  },
  computed: {
    ...mapGetters('lookup', [ 'conditions', 'countryCodes', 'warehouses', 'vendorRmaLineReasons' ]),
    receiveVal() {
      return parseInt(this.lineReceiveObj.received, 10);
    },
    sumQuantity() {
      return this.receiveDetailsArr.map(details => details.quantity).reduce((a, b) => a + b);
    },
    isRmaLineExist() {
      return Object.keys(this.rmaLine).length > 0;
    },
  },
  methods: {
    generateRefSN(i) {
      return 'serial-num-modal-'+i;
    },
    sumSplitQuantity(i) {
			return this.receiveDetailsArr[i].inventorySplits.map(details => details.quantity).reduce((a, b) => a + b);
    },

    readyMadeReceiveDetailObj() {
			return {
				id: 0,
				quantity: 0,
				cost: (this.isRmaLineExist) ? this.rmaLine.price : 0,
				dateCode: (this.isRmaLineExist) ? this.rmaLine.dateCode : null,
				lotCode: (this.isRmaLineExist) ? this.rmaLine.lotCode : null,
				revision: (this.isRmaLineExist) ? this.rmaLine.revision : null,
				conditionId: (this.isRmaLineExist) ? this.rmaLine.conditionId : 0,
				countryOfOriginId: (this.isRmaLineExist) ? this.rmaLine.countryOfOriginId : 0,
				comments: null,
			};
    },
    splitChange(index) {
      this.receiveDetailsArr[index].isSplit = !this.receiveDetailsArr[index].isSplit;

      if (this.receiveDetailsArr[index].isSplit) {
        this.receiveDetailsArr[index].inventorySplits.push(this.readyMadeReceiveDetailObj());
      } else {
        this.receiveDetailsArr[index].inventorySplits = [];
      }
    },
    async onReceiveInput() {
      if (this.receiveDetailsArr.length > 1) {
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to abandon these changes?`});
        if (deleteConfirmed) {
          this.tempReceive = this.lineReceiveObj.received;
          this.$emit('receiveInput');
        } else {
          this.lineReceiveObj.received = this.tempReceive;
        }
      } else {
        this.tempReceive = this.lineReceiveObj.received;
        this.$emit('receiveInput');
      }
    },
    onSplitQuantityChange(val, splitIndex, rcvIndex) {
      let quantity = this.receiveDetailsArr[rcvIndex].quantity;
      let lastIndexVal = this.receiveDetailsArr[rcvIndex].inventorySplits.length -1;

			if (val.newVal > quantity || this.sumSplitQuantity(rcvIndex) > quantity) {
				this.receiveDetailsArr[rcvIndex].inventorySplits[splitIndex].quantity = val.oldVal;
			}

			if (this.sumSplitQuantity(rcvIndex) < quantity && this.receiveDetailsArr[rcvIndex].inventorySplits[lastIndexVal].quantity > 0) {
				this.receiveDetailsArr[rcvIndex].inventorySplits.push(this.readyMadeReceiveDetailObj());
      } else if (this.sumSplitQuantity(rcvIndex) === quantity
        && (this.receiveDetailsArr[rcvIndex].inventorySplits[lastIndexVal].quantity == 0 || this.receiveDetailsArr[rcvIndex].inventorySplits[lastIndexVal].quantity == null)) {
				this.receiveDetailsArr[rcvIndex].inventorySplits.pop();
			} else if ((val.newVal == 0 || isNaN(val.newVal)) && this.receiveDetailsArr[rcvIndex].inventorySplits[lastIndexVal].quantity == null && this.receiveDetailsArr[rcvIndex].inventorySplits.length != 1) {
				this.receiveDetailsArr[rcvIndex].inventorySplits.pop();
			}
    },
    onQuantityChange($event, i) {
      let newVal = parseInt($event.target.value, 10);
      // let receiveVal = parseInt(this.lineReceiveObj.received, 10);
      // let sumQuantity = this.receiveDetailsArr.map(details => details.quantity).reduce((a, b) => a + b);

      if (newVal > this.receiveVal || this.sumQuantity > this.receiveVal) {
				this.receiveDetailsArr[i].quantity = this.tempQuantity[i];
			} else {
        this.tempQuantity[i] = newVal;
      }

      this.$emit('quantityChange', newVal)
    },
    onDeleteRow(index) {
      if (this.receiveDetailsArr[index].isSplit) {
        this.receiveDetailsArr[index].inventorySplits = [];
      }

      if (index == this.receiveDetailsArr.length - 1) {
        this.receiveDetailsArr.pop();
      } else {
        this.receiveDetailsArr.splice(index, 1);
      }
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      } else {
        return `${files.length} files selected`;
      }
    },
    showImageUpload(index) {
      const modalRef = "upload-image-"+index;
      this.$refs[modalRef].show();
    }
  },
  watch: {
  },

}
</script>

<style scoped>
  .split {
    font-size: 10px;
  }
  .max-number-width {
    width: 80px;
  }

  table {
    margin-top: 15px;
    border-top-style: double;
  }

  td {
    padding-left: 10px;
  }

  th {
    padding-left: 10px;
  }

  .highlight-text-field {
    background-color: #ffc107
  }

  .required-field {
    color: red
  }
</style>